import { VisitHistory } from '@dreryk/egabinet-visit-frontend-api';

import { VisitHistoryWithConfidentialDetails } from './types';

export const isVisitHistoryWithConfidentialDetails = (
   visit: VisitHistory
): visit is VisitHistoryWithConfidentialDetails => {
   return Boolean(visit.confidentialDetails);
};
